import React from 'react'
import { connect } from 'react-redux'
// import { login, logout, authorize } from 'core/modules/Login/Module'

export default Component => {
  return props => <ConnectedAuth component={Component} {...props} />
}

function AuthContainer({ component: Component, ...rest }) {
  return <Component {...rest} />
}

const ConnectedAuth = connect(
  state => ({
    authorized: state.General.authorized,
    user: state.General.user
  }),
  {
    // login,
    // logout,
    // authorize
  }
)(AuthContainer)
